export const SAVED_PASSENGERS_BOTTOM_SHEET = 'saved-passengers-bottom-sheet';
export const SAVED_PASSENGERS_RADIO_NAME = 'saved-passengers-radio';
export const SESSION_STORAGE_KEY = 'free-avia:local-saved-passengers';
